export default "__VITE_PUBLIC_ASSET__3e2931ba__"